// extracted by mini-css-extract-plugin
var _1 = "UploadImageModal-modulebox__ocpqW";
var _2 = "UploadImageModal-modulefileInput__rmyyB";
export { _1 as "box", _2 as "fileInput" }
